import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.26855 1.27972C3.9287 1.48869 3.9287 1.47818 4.36034 4.29923C4.99276 8.47834 5.61507 10.0371 6.2677 14.3938H16.9061"
      stroke="black"
      strokeWidth="0.765871"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.02749 18.7203C8.80368 18.7203 9.4329 18.0654 9.4329 17.2575C9.4329 16.4496 8.80368 15.7947 8.02749 15.7947C7.2513 15.7947 6.62207 16.4496 6.62207 17.2575C6.62207 18.0654 7.2513 18.7203 8.02749 18.7203Z"
      stroke="black"
      strokeWidth="0.765871"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3957 18.7168C16.1718 18.7168 16.8011 18.0619 16.8011 17.254C16.8011 16.4462 16.1718 15.7913 15.3957 15.7913C14.6195 15.7913 13.9902 16.4462 13.9902 17.254C13.9902 18.0619 14.6195 18.7168 15.3957 18.7168Z"
      stroke="black"
      strokeWidth="0.765871"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.3125 3.89508H19.7312"
      stroke="black"
      strokeWidth="0.765871"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7315 3.90857L17.4805 12.1871"
      stroke="black"
      strokeWidth="0.765871"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4784 12.1887L5.98438 12.1956"
      stroke="black"
      strokeWidth="0.765871"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { SvgComponent as CartIcon };
